module.exports = __webpack_public_path__ + "static/media/ic-current-loc-gray.02955e68.svg";